module.exports = __webpack_public_path__ + "img/eclat-du-moselle-cover.fce187df.jpg";